import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {useSelector} from "react-redux";
import Fallback from "./fallback";
import {getUserProfile} from "../../redux/Selectors/users.selector";

export const usePermissionCheck = (
  requiredPermissions = [],
  shouldHaveAllPermissions = true
) => {
  const user = useSelector(getUserProfile);
  const {user_permissions: userPermissions = []} = user;

  if (requiredPermissions?.length === 0) {
    return true;
  }

  let showContent;

  if (shouldHaveAllPermissions) {
    // Show content if the user has all of the permissions passed as props
    showContent = requiredPermissions?.every((requiredPerm) =>
      userPermissions?.some((userPerm) => userPerm.value === requiredPerm)
    );
  } else {
    // Show content if the user has any of the permissions passed as props
    showContent = requiredPermissions?.some((requiredPerm) =>
      userPermissions?.some((userPerm) => userPerm.value === requiredPerm)
    );
  }

  return showContent;
};

const ProtectedContent = (props) => {
  const {
    children,
    perms: requiredPermissions = [],
    shouldHaveAllPermissions = true,
    showFallback = false,
    customFallback: CustomFallback,
  } = props;

  const showContent = usePermissionCheck(requiredPermissions, shouldHaveAllPermissions);

  // Either render the protected content or an alterative for unauthorized users
  return showContent ? (
    <Fragment>{children}</Fragment>
  ) : showFallback ? (
    <Fragment>{CustomFallback ? <CustomFallback /> : <Fallback />}</Fragment>
  ) : null;
};

ProtectedContent.propTypes = {
  children: PropTypes.node,
  perms: PropTypes.array,
  shouldHaveAllPermissions: PropTypes.bool,
  showFallback: PropTypes.bool,
  customFallback: PropTypes.element,
};

export default ProtectedContent;
